import { render, staticRenderFns } from "./Accepted.vue?vue&type=template&id=6558f8f6&scoped=true"
import script from "./Accepted.vue?vue&type=script&lang=js"
export * from "./Accepted.vue?vue&type=script&lang=js"
import style0 from "./Accepted.vue?vue&type=style&index=0&id=6558f8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558f8f6",
  null
  
)

export default component.exports